import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  CardMedia, 
  Button,
  CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../services/FirestoreService';
import { getBlogPosts } from '../../services/FirestoreService';

const BlogList: React.FC = () => {
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const fetchedBlogPosts = await getBlogPosts();
        setBlogPosts(fetchedBlogPosts);
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  if (loading) {
    return (
      <Container className="flex justify-center items-center h-64">
        <CircularProgress />
      </Container>
    );
  }

  return (
    <div className="container mx-auto py-8 px-4">
      <Typography variant="h4" component="h1" className="mb-6 text-2xl md:text-3xl">
        Blog Yazıları
      </Typography>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {blogPosts.map((post) => (
          <Card 
            key={post.id}
            component={Link} 
            to={`/blog/${post.id}`}
            className="no-underline h-full flex flex-col transition-transform duration-300 hover:scale-103"
          >
            <CardMedia
              component="img"
              height="200"
              image={post.image}
              alt={post.title}
            />
            <CardContent className="flex-grow">
              <Typography variant="h6" component="div" className="font-bold">
                {post.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mt-2">
                {post.excerpt}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </div>
      
      {blogPosts.length === 0 && (
        <div className="text-center py-8">
          <Typography variant="h6">
            Henüz blog yazısı eklenmemiş.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default BlogList;